var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ReactGA from 'react-ga';
import reactGtmModule from 'react-gtm-module';
import * as Tracker from 'smartpi-tracker';
import { Container } from 'typedi';
import { UserManager } from './user';
var Analytics = /** @class */ (function () {
    function Analytics(params) {
        var ga = params.ga, tracker = params.tracker;
        this.ga = ga;
        this.tracker = tracker;
    }
    Analytics.prototype.init = function (channel) {
        if (channel === void 0) { channel = 'default'; }
        ReactGA.initialize(this.ga.trackingCode, { debug: false });
        ReactGA.set({
            campaignId: channel,
        });
        Tracker.initialize(__assign({}, this.tracker));
        Tracker.set({
            campaignId: channel,
        });
    };
    Analytics.prototype.initTagManager = function () {
        var tagManagerArgs = {
            gtmId: this.ga.gtmId,
        };
        reactGtmModule.initialize(tagManagerArgs);
    };
    Analytics.trackGAPage = function (page, data) {
        var user = Container.get(UserManager).getUser();
        var userUuid = user && user.uuid;
        var userId = user && user.id;
        ReactGA.set({
            page: page,
            userId: userUuid,
            dimension1: userUuid,
        });
        ReactGA.pageview(page);
        Tracker.set({
            page: page,
            userUuid: userUuid,
            userId: userId,
        });
        Tracker.pageview(page, { data: data });
    };
    Analytics.event = function (args, data) {
        ReactGA.event(args);
        Tracker.event(args, data);
    };
    Analytics.identify = function (user) {
        if (!user) {
            return;
        }
        ReactGA.set({
            userId: user.uuid,
            dimension1: user.uuid,
        });
        Tracker.set({
            userId: user.id,
            userUuid: user.uuid,
        });
    };
    return Analytics;
}());
export { Analytics };
//# sourceMappingURL=analytics.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/services/analytics.js
// module id = 466
// module chunks = 0